import styled from 'styled-components';
import { themed } from '@/shared/ui/core';

export const BidHistory = styled.div`
  .Title {
    margin-bottom: 1.5rem;
    color: ${themed('primary.main')};
  }
`;

export const Table = styled.table`
  width: 100%;
  display: table;
  border-collapse: collapse;
  text-align: left;
  padding: 0;
`;

export const Row = styled.tr`
  text-align: left;
  padding: 0;
  border-bottom: solid 0.125rem ${themed('primary.gray')};

  td {
      column-span: all;

      >span:first-of-type {
        margin-right: 0.5rem;
      }
    }

  &:first-of-type {
    border-bottom: none;
  }
`;

export const TableHeader = styled.th`
  padding: 0;

  &:first-of-type {
    padding-right: 0.75rem;
  }
`;

export const TableCell = styled.td`
  padding: 1.25rem 0 1.25rem 0.125rem;

  &:first-of-type {
    padding-right: 0.75rem;
  }

  span {
    font-size: 1rem;
  }

`;
